<div class="content">
  <div class="content-panel">
    <h2 translate>page.commissions.planning.title</h2>

    <div class="row text-center align-items-center">
      <!-- Bouton d'ajout -->
      <div class="col-md-1">
        <button class="btn btn-primary" [routerLink]="['../new/edit']">Ajouter</button>
      </div>

      <!-- Boutons de navigation -->
      <div class="col-md-3">
        <div class="btn-group">
          <button type="button" class="btn btn-primary" (click)="previousPeriod()">
            {{ 'page.commissions.planning.precedent' | translate }}
          </button>

          <button type="button" class="btn btn-outline-secondary" (click)="goToToday()">
            {{ 'page.commissions.planning.aujourdhui' | translate }}
          </button>

          <button type="button" class="btn btn-primary" (click)="nextPeriod()">
            {{ 'page.commissions.planning.suivant' | translate }}
          </button>
        </div>
      </div>

      <!-- Afficher la date de l'agenda -->
      <div class="col-md-4">
        <h3>
          <ng-container *ngIf="view !== 'year'; else yearTitle">
            {{ viewDate | calendarDate:(view + 'ViewTitle'):locale:weekStartsOn }}
          </ng-container>
          <ng-template #yearTitle>
            {{ viewDate | date:'yyyy' }}
          </ng-template>
        </h3>
      </div>

      <!-- Boutons de sélection du type de vue -->
      <div class="col-md-4">
        <div class="btn-group">
          <div class="btn btn-primary pointer"
               (click)="setView('year')"
               (keydown.enter)="setView('year')"
               [class.active]="view === 'year'">
            Année
          </div>

          <div class="btn btn-primary pointer"
               (click)="setView(CalendarView.Month)"
               (keydown.enter)="setView(CalendarView.Month)"
               [class.active]="view === CalendarView.Month">
            {{ 'page.commissions.planning.mois' | translate }}
          </div>

          <div class="btn btn-primary pointer"
               (click)="setView(CalendarView.Week)"
               (keydown.enter)="setView(CalendarView.Week)"
               [class.active]="view === CalendarView.Week">
            {{ 'page.commissions.planning.semaine' | translate }}
          </div>

          <div class="btn btn-primary pointer"
               (click)="setView(CalendarView.Day)"
               (keydown.enter)="setView(CalendarView.Day)"
               [class.active]="view === CalendarView.Day">
            {{ 'page.commissions.planning.jour' | translate }}
          </div>
        </div>
      </div>
    </div>

    <form class="filtre-form" [formGroup]="formFiltre" #form="ngForm">
      <label translate>label.filtrer</label>
      <select formControlName="animateur" class="form-select"
        [compareWith]="compareAnimateurs"
        [ngClass]="{'select-placeholder' : formFiltre.get('animateur').value === null}">
        <option [ngValue]="null" class="placeholder" translate>
          page.commissions.planning.select-animateur
        </option>
        <option *ngFor="let animateur of animateurs" [ngValue]="animateur">
          {{ animateur.prenom }} {{ animateur.nom }}
        </option>
      </select>
    </form>

    <br />

    <!-- Vue agenda -->
    <div [ngSwitch]="view">
      <!-- Vue année -->
      <div *ngSwitchCase="'year'" class="year-view container-fluid px-0">
        <div class="row g-3">
          <div class="col-12 col-md-6 col-xl-4" *ngFor="let month of yearMonthsWithEvents">
            <div class="card h-100 shadow-sm year-month-card">
              <div class="card-header d-flex justify-content-between align-items-center">
                <span class="fw-semibold pointer year-month-title" (click)="openMonth(month.date)" (keydown.enter)="openMonth(month.date)">
                  {{ month.date | date:'MMMM yyyy' }}
                </span>
       <span class="badge bg-secondary">
                  {{ getEventsForMonth(month.date).length }}
                </span>
              </div>

              <div class="card-body p-2">
                <ng-container *ngIf="getEventsForMonth(month.date).length > 0; else noMeetingMonth">
                  <div
                    class="year-meeting-item"
                    *ngFor="let event of month.events"
                    (click)="handleEvent('Clicked', event)"
                    (keydown.enter)="handleEvent('Clicked', event)">
                    <div class="year-meeting-color"
                        [ngStyle]="{ 'background-color': event.color?.primary }">
                    </div>

                    <div class="year-meeting-content">
                      <strong>{{ event.meta.commission.numero }}</strong>
                      <span class="year-meeting-date">
                        - {{ event.start | date:'dd/MM/yyyy' }}
                      </span>
                    </div>
                  </div>
                </ng-container>

                <ng-template #noMeetingMonth>
                  <div class="text-muted small fst-italic">
                    Aucune réunion
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Vue au mois -->
      <mwl-calendar-month-view
        *ngSwitchCase="CalendarView.Month"
        [viewDate]="viewDate"
        [events]="listeEvents"
        [refresh]="refresh"
        [activeDayIsOpen]="activeDayIsOpen"
        (eventClicked)="handleEvent('Clicked', $event.event)"
        (dayClicked)="dayClicked($event.day)"
        (eventTimesChanged)="eventTimesChanged($event)"
        [locale]="locale"
        [weekStartsOn]="weekStartsOn"
        [weekendDays]="weekendDays"
        [cellTemplate]="monthCellTemplate">
      </mwl-calendar-month-view>

      <!-- Vue à la semaine -->
      <mwl-calendar-week-view
        *ngSwitchCase="CalendarView.Week"
        [viewDate]="viewDate"
        [events]="listeEvents"
        [refresh]="refresh"
        [dayStartHour]="8"
        [dayEndHour]="20"
        (eventClicked)="handleEvent('Clicked', $event.event)"
        (eventTimesChanged)="eventTimesChanged($event)"
        (hourSegmentClicked)="onHourSegmentClicked($event)"
        [locale]="locale"
        [weekStartsOn]="weekStartsOn"
        [weekendDays]="weekendDays">
      </mwl-calendar-week-view>

      <!-- Vue à la journée -->
      <mwl-calendar-day-view
        *ngSwitchCase="CalendarView.Day"
        [viewDate]="viewDate"
        [events]="listeEvents"
        [refresh]="refresh"
        [dayStartHour]="8"
        [dayEndHour]="20"
        (eventClicked)="handleEvent('Clicked', $event.event)"
        (eventTimesChanged)="eventTimesChanged($event)"
        (hourSegmentClicked)="onHourSegmentClicked($event)"
        [locale]="locale">
      </mwl-calendar-day-view>
    </div>

    <ng-template #monthCellTemplate let-day="day" let-locale="locale">
      <div class="cal-cell-top">
        <span class="cal-day-number">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
      </div>
      <div class="event-month-container">
        <div *ngFor="let event of day.events | slice:0:maxEventsMonthView"
             placement="top"
             [ngbTooltip]="tipContent"
             [ngStyle]="{'background-color':event.color.secondary,'border-color':event.color.primary }"
             class="event-month">
          <strong>{{ event.meta.commission.numero }}</strong>
          <span class="overflow-ellipsis">{{ event.meta.commission.salle.nom }}</span>
          <span>{{ event.meta.commission.debut | date:'H:mm' }} - {{ event.meta.commission.fin | date:'H:mm' }}</span>

          <ng-template #tipContent>
            <div class="month-event-tooltip" [innerHTML]="event.title"></div>
          </ng-template>
        </div>

        <div *ngIf="day.events.length > maxEventsMonthView">
          + {{ day.events.length - maxEventsMonthView }} {{ 'label.autres' | translate | lowercase }}
        </div>
      </div>
    </ng-template>

    <ng-template #yearMonthCellTemplate let-day="day" let-locale="locale">
      <div class="cal-cell-top">
        <span class="cal-day-number">
          {{ day.date | calendarDate:'monthViewDayNumber':locale }}
        </span>
      </div>

      <div class="year-month-events" *ngIf="day.events.length > 0">
        <div class="year-month-event-dot"
             *ngFor="let event of day.events | slice:0:3"
             [ngStyle]="{'background-color': event.color?.primary}">
        </div>

        <small class="year-month-more" *ngIf="day.events.length > 3">
          +{{ day.events.length - 3 }}
        </small>
      </div>
    </ng-template>

  </div>
</div>
